import React from 'react';

import {labels} from '../../../../../util/utils';

import {IconoirCustomUserManage} from '@ey-xd/motif-icon';

import MAForm from './MAForm';
import StyledDropdown from '../StyledDropdown';
import ToolbarButton from '../ToolbarButton';

const ManageAccess = () => {
	const renderTrigger = () => {
		const props = {
			svg: IconoirCustomUserManage,
			label: labels.toolbarManageAccess
		};

		return <ToolbarButton {...props} />;
	};

	const props = {
		placement: 'bottom-right',
		trigger: renderTrigger(),
		reversed: true,
		topfix: true
	};

	return (
		<StyledDropdown {...props}>
			<MAForm />
		</StyledDropdown>
	);
};

export default ManageAccess;
